import {BrowserRouter, Route,Switch} from "react-router-dom";
import "./index.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import News from "./views/News";
import NewsDetails from "./views/NewsDetails";
import NewsMain from "./views/NewsMain";
import SignIn from "./views/NewsSignIn";
import NewsRegister from "./views/NewsRegister";
import NoMatch from "./views/NoMatch";
import Requests from "./views/Requests";
import Students from "./views/Students";



function App() {
  return (
    <BrowserRouter>
        <Switch>
            <Route exact path='/'><NewsMain /></Route>
            <Route exact path='/news'><News /> </Route>
            <Route exact path='/details/:id'><NewsDetails /></Route>
            <Route exact path='/signin'><SignIn /></Route>
            <Route exact path='/register'><NewsRegister /></Route>
            <Route exact path='/requests'><Requests /></Route>
            <Route exact path='/students'><Students /></Route>
            <Route exact path="*"><NoMatch /></Route>
        </Switch>
    </BrowserRouter>
  );
}

export default App;
